import { render } from "./CourseDetailsScreen.vue?vue&type=template&id=158e170d&scoped=true"
import script from "./CourseDetailsScreen.vue?vue&type=script&lang=js"
export * from "./CourseDetailsScreen.vue?vue&type=script&lang=js"

import "./CourseDetailsScreen.vue?vue&type=style&index=0&id=158e170d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158e170d"]])

export default __exports__